// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn[data-v-3c5a05b8]{\r\n  color: white !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
